<template>
  <div class="position-relative mb-3">
    <section class="section-shaped my-0">
      <div class="shape shape-style-1 bg-gradient-navyDark shape-skew alpha-4">
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
      </div>
      <div class="container shape-container">
        <b-col cols="12" class="title-section-first title-contact pr-0">
          <h1>فرم تماس</h1>
          <p>
            برای ارتباط با کارشناسان ما می‌توانید از طریق فرم زیر پیام خود را
            ثبت کنید. همکاران ما در اولین فرصت با شما تماس خواهند گرفت.
          </p>
        </b-col>
      </div>
    </section>

    <section class="section-skew mt-2">
      <div class="container">
        <b-row class="section-tour justify-content-center">
          <b-col cols="12" xl="8" lg="8" md="9" sm="12" xs="12">
            <card gradient="secondary" shadow body-classes="p-lg-5">
              <base-input
                v-model="form.name"
                alternative
                placeholder="نام و نام خانوادگی*"
                addon-left-icon="ni ni-circle-08"
                :class="{ 'is-invalid': !form.name && submitted }"
              ></base-input>
              <base-input
                v-model="form.companyName"
                alternative
                placeholder="نام شرکت"
                addon-left-icon="ni ni-building"
              ></base-input>
              <base-input
                v-model="form.mobile"
                alternative
                placeholder="شماره تماس*"
                addon-left-icon="fa fa-phone"
                :class="{ 'is-invalid': form.mobile && !isMobileValid }"
              ></base-input>
              <small v-if="form.mobile && !isMobileValid" class="text-danger">
                شماره موبایل وارد شده صحیح نیست!
              </small>
              <base-input
                v-model="form.email"
                alternative
                placeholder="ایمیل"
                addon-left-icon="ni ni-email-83"
                :class="{ 'is-invalid': form.email && !isEmailValid }"
              ></base-input>
              <small v-if="form.email && !isEmailValid" class="text-danger">
                ایمیل وارد شده صحیح نیست!
              </small>
              <base-input class="mb-4">
                <textarea
                  v-model="form.description"
                  class="form-control form-control-alternative"
                  name="name"
                  rows="4"
                  cols="80"
                  placeholder="توضیحات*"
                  :class="{ 'is-invalid': !form.description && submitted }"
                ></textarea>
              </base-input>
              <base-button
                :disabled="!isFormValid"
                type="navyDark"
                round
                block
                size="lg"
                @click="submitForm"
              >
                ارسال
              </base-button>
            </card>
          </b-col>
        </b-row>
      </div>
    </section>

    <button v-if="showScrollButton" @click="scrollToTop" class="scroll-to-top">
      <i class="fa fa-arrow-up" aria-hidden="true"></i>
    </button>
  </div>
</template>

<script>
export default {
  name: "Contact",
  data() {
    return {
      form: {
        name: "",
        companyName: "",
        mobile: "",
        email: "",
        description: "",
      },
      showScrollButton: false,
      submitted: false,
    };
  },
  computed: {
    isMobileValid() {
      return this.validateMobileNumber(this.form.mobile);
    },
    isEmailValid() {
      return !this.form.email || this.validateEmail(this.form.email);
    },
    isFormValid() {
      return (
        this.form.name &&
        this.isMobileValid &&
        this.isEmailValid &&
        this.form.description
      );
    },
  },
  methods: {
    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    },
    handleScroll() {
      this.showScrollButton = window.scrollY > 300;
    },
    validateMobileNumber(mobile) {
      const pattern = /^(?:\+98|0)?9\d{9}$/;
      return pattern.test(mobile);
    },
    validateEmail(email) {
      const pattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return pattern.test(email);
    },
    resetForm() {
      this.form = {
        name: "",
        companyName: "",
        mobile: "",
        email: "",
        description: "",
      };
      this.submitted = false;
    },
    async submitForm() {
      this.submitted = true;
      if (!this.isFormValid) {
        return;
      }

      try {
        const response = await fetch(`${this.$baseUrl}/v1/contactForm/new`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(this.form),
        });

        if (response.status === 200) {
          const data = await response.json();
          this.$toast.success(data.message);
          this.resetForm();
        } else {
          const errorData = await response.json();
          this.$toast.error(errorData.message);
          this.resetForm();
        }
      } catch (error) {
        this.$toast.error(error.message);
        this.resetForm();
      }
    },
  },
  mounted() {
    window.scrollTo(0, 0);
    window.addEventListener("scroll", this.handleScroll);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
  },
};
</script>
